import { render, staticRenderFns } from "./ProductsAdaptationModal.vue?vue&type=template&id=76972e90&scoped=true&"
import script from "./ProductsAdaptationModal.vue?vue&type=script&lang=js&"
export * from "./ProductsAdaptationModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAdaptationModal.vue?vue&type=style&index=0&id=76972e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76972e90",
  null
  
)

export default component.exports